import { KeyboardArrowDown, Edit } from "@material-ui/icons";
import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { connect } from "react-redux";
import noRecord from "../../assets/img/no-record.png";
import DeletePrompt from "../Common/DeletePrompt";
import { Field, Form, Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import * as message from "../../config/CommonMessages";
import {
  addBillingItems,
  getAllBillingItems,
  editBillingItems,
} from "../../actions/BillingActions";
import * as code from "../../config/Constants";
import { getUserRolesActionNew } from "../../actions/UserActions";

import {
  getAllAiVersions,
  GetAllAssignedVersion,
  UpdateAiVersionItem,
  getAiServices,
  updateAiVersionToService,
  addAiVersionToparticularService,
} from "../../actions/AiActions";

class AssignVersion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: props.title || "Assign Versions",
      showAddModal: false,
      showEditPrompt: false,
      versionItemCode: "",
      serviceName: "",
      service: "",
      updateAssignedId: "",
      aiModel: "", // Add new state for aiModel
      versions: [],
      assignedVersionsData: [],
      services: [],
      itemCodeduplicat: false,
      showLoader: false,
      roles: [],
      assignData: [],
    };
  }
  columns = [
    {
      name: "Service",
      selector: "service",
      sortable: true,
      ignoreRowClick: true,
      width: "30%",
    },
    {
      name: "AI Model",
      selector: "aiModel",
      sortable: true,
      ignoreRowClick: true,
      width: "30%",
    },
    {
      name: "Version Item Code",
      selector: "shortcode",
      sortable: true,
      ignoreRowClick: true,
      width: "30%",
    },
    {
      name: "ACTION",
      selector: "action",
      // right: true,
      ignoreRowClick: true,
      width: "10%",
    },
  ];

  openAddModal() {
    this.setState({
      showAddModal: !this.state.showAddModal,
      versionItemCode: "",
      Service: "",
      aiModel: "", // Add aiModel to state
      itemCodeduplicat: false,
    });
  }

  componentWillMount() {
    this.getAllAIVersions();
    this.getAllAssignedVersions();
    this.getAllServices();

    console.log("assign", this.state.assignedVersionsData);
  }

  getalluserroles() {
    this.setState({
      showLoader: true,
    });
    this.props.getUserRolesActionNew().then((result) => {
      this.setState({
        roles: result,
        showLoader: false,
      });
      // console.log("result119", result);
    });
  }
  getAllServices() {
    // console.log("Fetching AI services...");
    this.setState({
      showLoader: true,
    });
    this.props
      .getAiServices()
      .then((result) => {
        // console.log("AI Services API Response:", result);
        // console.log("AI Services Data:", result.data);
        this.setState(
          {
            services:
              Array.isArray(result.data) && result.data.length > 0
                ? result.data
                : [],
            showLoader: false,
          },
          () => {
            //  console.log("Updated services state:", this.state.services);
          }
        );
      })
      .catch((error) => {
        //    console.error("Error fetching AI services:", error);
        this.setState({ showLoader: false });
      });
  }
  getAllAIVersions() {
    this.setState({
      showLoader: true,
    });
    this.props.getAllAiVersions().then((result) => {
      this.setState({
        versions:
          Array.isArray(result.data) && result.data.length > 0
            ? result.data
            : [],
        showLoader: false,
      });
    });
  }
  // getallVersions() {
  //   this.setState({
  //     showLoader: true,
  //   });
  //   this.props.GetAiVersion().then((result) => {
  //     this.setState({
  //       versions:
  //         Array.isArray(result.data) && result.data.length > 0
  //           ? result.data
  //           : [],
  //       showLoader: false,
  //     });
  //   });
  // }

  getAllAssignedVersions() {
    this.setState({
      showLoader: true,
    });
    this.props.GetAllAssignedVersion().then((result) => {
      this.setState({
        assignedVersionsData:
          Array.isArray(result.data) && result.data.length > 0
            ? result.data
            : [],
        showLoader: false,
      });
    });
  }

  openEditPrompt(billingItem) {
    // console.log("billingItem", billingItem);
    this.setState({
      showEditPrompt: true,
      versionItemCode: billingItem.versionItemCode,
      Service: billingItem.Service,
    });
  }

  addAssignServiceVersion(values) {
    //console.log("val",values);
    this.props
      .addAiVersionToparticularService(values)
      .then((res) => {
        if (res.status === code.OK) {
          this.setState({
            showAddModal: false,
            versionItemCode: "",
            Service: "",
            aiModel: "", // Add aiModel to state
            itemCodeduplicat: false,
          });
          this.getAllAssignedVersions();
        } else {
          if (res.data === "duplicate") {
            this.setState({
              itemCodeduplicat: true,
            });
            //  toastMessage("error", "The version is already assigned");
          }
        }
      })
      .catch((err) => {});
  }

  openEditAssignedVersion(data) {
    this.setState({
      showEditPrompt: true,
      service: data.serviceCodeId._id,
      updateAssignedId: data._id,
      serviceName: data.serviceCodeId.service_description,
      aiModel: data.aiModel, // Add aiModel to state
      versionItemCode: data.versionItemCodeId._id,
    });
    // console.log("version item code", data.versionItemCodeId._id);
  }

  updateAiVersion(values) {
    this.props
      .updateAiVersionToService(values)
      .then((res) => {
        this.setState({
          showEditPrompt: false,
          versionItemCode: "",
          updateAssignedId: "",
          service: "",
          serviceName: "",
          aiModel: "", // Add aiModel to state
        });
        this.getAllAssignedVersions();
      })
      .catch((err) => {});
  }

  render() {
    let rows = [];
    for (
      var i = 0, len = this.state.assignedVersionsData.length;
      i < len;
      i++
    ) {
      let versions = this.state.assignedVersionsData[i];

      console.log("versionss", versions.serviceCodeId);
      let data = {
        service: versions.serviceCodeId.service_description,
        aiModel: versions.aiModel === "majimeai" ? "Majime AI" : "Open AI",
        shortcode: versions.versionItemCodeId.versionItemCode,
        action: (
          <div className="action-btns">
            <Button
              variant="transparent"
              onClick={() => {
                this.openEditAssignedVersion(versions);
              }}
            >
              <Edit />
            </Button>
          </div>
        ),
      };

      rows.push(data);
    }
    return (
      <div>
        <Row className="mx-0 page-head-row page-head-row-big align-items-center">
          <Col className="col-auto">
            <h4 className="title-med mt-0 pt-1">{this.state.title}</h4>
          </Col>
          <Col align="right">
            <Button
              onClick={() => {
                this.openAddModal();
              }}
              className="btn btn-primary btn-blue btn-head w-140"
            >
              Add
            </Button>
          </Col>
        </Row>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="dt-content-area">
            <DataTable
              columns={this.columns}
              data={rows}
              noDataComponent={
                <div className="no-transaction no-record no-datatable">
                  <div className="no-transaction-inner">
                    <img src={noRecord} alt="no record" />
                    <p>No Data Found</p>
                  </div>
                </div>
              }
              highlightOnHover={true}
              className="rdt-requests"
              sortIcon={<KeyboardArrowDown className="color-grey-1" />}
              onRowSelected={this.getSelectedRows}
            />

            {this.state.showLoader === true && (
              <div className="page-loader">
                <div className="page-loader-inner">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            )}

            <DeletePrompt
              deletePrompt={this.state.deletePrompt}
              itemId={this.state.contingencyID}
              cancel={() => {
                this.setState({ deletePrompt: false });
              }}
              deleteConfirm={this.deleteContingency}
            />

            <Modal
              show={this.state.showAddModal}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med modal-400"
              backdrop={false}
            >
              <Modal.Header>
                <Modal.Title id="example-custom-modal-styling-title">
                  Assign Version
                </Modal.Title>
              </Modal.Header>

              <Modal.Body className="pb-0">
                <Formik
                  validateOnBlur={true}
                  initialValues={{
                    service: "",
                    versionItemCode: "",
                    aiModel: "", // Add aiModel field
                  }}
                  enableReinitialize={true}
                  validationSchema={Yup.object().shape({
                    service: Yup.string().required("Service is required"),
                    versionItemCode: Yup.string().required(
                      "Version Item Code is required"
                    ),
                    aiModel: Yup.string().required("AI Model is required"), // Add validation
                  })}
                  onSubmit={(values) => {
                    let data = {
                      versionItemCodeId: values.versionItemCode,
                      serviceCodeId: values.service,
                      aiModel: values.aiModel, // Add aiModel to data
                    };
                    this.addAssignServiceVersion(data);
                  }}
                >
                  {({ values, errors, touched, handleChange, handleBlur }) => (
                    <Form
                      className="form-sm form-admin"
                      style={{ marginBottom: 15 }}
                    >
                      <div className="form-group">
                        <label>
                          Service
                          <span className="text-danger"> *</span>
                        </label>

                        <select
                          className="form-control"
                          name="service"
                          value={values.service}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <option value="">Select Service</option>

                          {this.state.services &&
                            this.state.services.map((service) => (
                              <>
                                <option key={service._id} value={service._id}>
                                  {service.service_description}
                                </option>
                              </>
                            ))}
                        </select>
                        <ErrorMessage
                          name="Service"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />

                        {this.state.itemCodeduplicat ? (
                          <div className="text-danger">
                            This Service Already Assigned a Version.
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="form-group">
                        <label>
                          AI Model
                          <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          name="aiModel"
                          value={values.aiModel}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <option value="">Select AI Model</option>
                          <option value="majimeai">Majime AI</option>
                          <option value="openai">Open AI</option>
                        </select>
                        <ErrorMessage
                          name="aiModel"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>

                      <div className="form-group">
                        <label>
                          Ai Version Code
                          <span className="text-danger"> *</span>
                        </label>

                        <select
                          className="form-control"
                          name="versionItemCode"
                          value={values.versionItemCode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <option value="">Select Version</option>
                          {this.state.versions &&
                            this.state.versions.map((item) => {
                              if (item.Isactive) {
                                if (
                                  values.aiModel === "majimeai" &&
                                  item.versionItemCode !== "majimeai"
                                ) {
                                  return null;
                                }
                                if (
                                  values.aiModel === "openai" &&
                                  item.versionItemCode === "majimeai"
                                ) {
                                  return null;
                                }
                                return (
                                  <option key={item._id} value={item._id}>
                                    {item.versionItemCode}
                                  </option>
                                );
                              }
                              return null;
                            })}
                        </select>

                        <ErrorMessage
                          name="versionItemCode"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>

                      <Button
                        variant="primary"
                        className="btn-blue w-140"
                        type="submit"
                        style={{ marginRight: 10 }}
                      >
                        Add
                      </Button>
                      <Button
                        variant="primary"
                        className="btn-blue btn-outlined w-140"
                        onClick={() => {
                          this.setState({
                            showAddModal: false,
                            versionItemCode: "",
                            Isactive: false,
                            itemCodeduplicat: false,
                          });
                        }}
                      >
                        Cancel
                      </Button>
                    </Form>
                  )}
                </Formik>
              </Modal.Body>
            </Modal>

            {/* Edit Data Modal */}
            <Modal
              show={this.state.showEditPrompt}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med modal-400"
              backdrop={false}
            >
              <Modal.Header>
                <Modal.Title id="example-custom-modal-styling-title">
                  Edit Ai Version
                </Modal.Title>
              </Modal.Header>

              <Modal.Body className="pb-0">
                <Formik
                  validateOnBlur={true}
                  initialValues={{
                    service: this.state.service,
                    serviceName: this.state.serviceName,
                    assignedId: this.state.updateAssignedId,
                    versionItemCode: this.state.versionItemCode,
                    aiModel: this.state.aiModel, // Add aiModel to edit form
                  }}
                  enableReinitialize={true}
                  validationSchema={Yup.object().shape({
                    // service: Yup.string().required("Service is required"),
                    versionItemCode: Yup.string().required(
                      "Version Item Code is required"
                    ),
                    aiModel: Yup.string().required("AI Model is required"), // Add validation
                  })}
                  onSubmit={(values) => {
                    let data = {
                      id: values.assignedId,
                      versionItemCodeId: values.versionItemCode,
                      serviceCodeId: values.service,
                      aiModel: values.aiModel, // Add aiModel to data
                    };
                    this.updateAiVersion(data);
                  }}
                >
                  {({ values, errors, touched, handleChange, handleBlur }) => (
                    <Form
                      className="form-sm form-admin"
                      style={{ marginBottom: 15 }}
                    >
                      <div className="form-group">
                        <label>
                          Service
                          <span className="text-danger"> *</span>
                        </label>
                        <Field
                          type="text"
                          className="form-control"
                          name="serviceName"
                          readOnly
                        />
                        <ErrorMessage
                          name="serviceName"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>

                      <div className="form-group">
                        <label>
                          AI Model
                          <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-control"
                          name="aiModel"
                          value={values.aiModel}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <option value="">Select AI Model</option>
                          <option value="majimeai">Majime AI</option>
                          <option value="openai">Open AI</option>
                        </select>
                        <ErrorMessage
                          name="aiModel"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>

                      <div className="form-group">
                        <label>
                          AI Version Code
                          <span className="text-danger"> *</span>
                        </label>

                        <select
                          className="form-control"
                          name="versionItemCode"
                          value={values.versionItemCode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <option value="">
                            Select Version
                          </option>
                          {this.state.versions &&
                            this.state.versions.map((item) => {
                              if (item.Isactive) {
                                if (
                                  values.aiModel === "majimeai" &&
                                  item.versionItemCode !== "majimeai"
                                ) {
                                  return null;
                                }
                                if (
                                  values.aiModel === "openai" &&
                                  item.versionItemCode === "majimeai"
                                ) {
                                  return null;
                                }
                                return (
                                  <option key={item._id} value={item._id}>
                                    {item.versionItemCode}
                                  </option>
                                );
                              }
                              return null;
                            })}
                        </select>

                        <ErrorMessage
                          name="versionItemCode"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>

                      <Button
                        variant="primary"
                        className="btn-blue w-140"
                        type="submit"
                        style={{ marginRight: 10 }}
                      >
                        Update
                      </Button>
                      <Button
                        variant="primary"
                        className="btn-blue btn-outlined w-140"
                        onClick={() => {
                          this.setState({
                            showEditPrompt: false,
                            versionItemCode: "",
                            Service: "",
                            aiModel: "", // Add aiModel to state
                          });
                        }}
                      >
                        Cancel
                      </Button>
                    </Form>
                  )}
                </Formik>
              </Modal.Body>
            </Modal>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {
    addBillingItems,
    getAllBillingItems,
    editBillingItems,
    getUserRolesActionNew,
    GetAllAssignedVersion,
    getAiServices,
    getAllAiVersions,
    GetAllAssignedVersion,

    updateAiVersionToService,
    addAiVersionToparticularService,
  }
)(AssignVersion);
